import { render, staticRenderFns } from "./exhibitions.vue?vue&type=template&id=f35f7a06&scoped=true&"
import script from "./exhibitions.vue?vue&type=script&lang=js&"
export * from "./exhibitions.vue?vue&type=script&lang=js&"
import style0 from "./exhibitions.vue?vue&type=style&index=0&id=f35f7a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35f7a06",
  null
  
)

export default component.exports